import OSS from 'ali-oss';

// 定义一个变量来存储单例的 OSS 客户端实例
let ossClientInstance = null;

// 自定义请求头
const defaultHeaders = {
    // 'x-oss-storage-class': 'Standard',
    // 'x-oss-object-acl': 'private',
    // 'Content-Disposition': 'attachment; filename="example.txt"',
    // 'x-oss-tagging': 'Tag1=1&Tag2=2',
    // 'x-oss-forbid-overwrite': 'true'
};

// 封装获取 OSS 客户端单例的函数
export const getOSSClient = (region, accessKeyId, accessKeySecret, bucket,endpoint) => {
    if (!ossClientInstance) {
        ossClientInstance = new OSS({
            region,
            accessKeyId,
            accessKeySecret,
            bucket,
            endpoint
        });
    }
    return ossClientInstance;
};

// 封装上传文件函数，同时使用默认请求头
export const uploadFileToOSS = async (file, fileBlob, region = 'oss-cn-hangzhou', accessKeyId = 'LTAI5tKgYaBKRRpC2ae1RgJC', accessKeySecret = 'CATEKYZphuuIudOa1QdIfUbkotSgb6', bucket = 'eyo88',endpoint = 'oss-cn-hangzhou.aliyuncs.com', headers = defaultHeaders) => {
  if (!fileBlob) {
    throw new Error('请选择要上传的文件');
  }
  const client = getOSSClient(region, accessKeyId, accessKeySecret, bucket,endpoint);

  try {
    const fileName = `/${_getTime()}/${file.lastModified}${Date.now()}.${file.type.split('image/')[1]}`;
    const result = await client.put(fileName, fileBlob, { headers });
    return { ...result.res, url: `https://file.hswlkj.com/${result.name}`, name: result.name, fileName: file.name };
  } catch (e) {
    console.error('上传失败:', e);
    throw e;
  }
};

function _getTime() {
  // 创建一个新的 Date 对象
  let today = new Date();

  // 获取年份
  let year = today.getFullYear();

  // 获取月份（注意：月份是从 0 开始的，所以需要加 1）
  let month = today.getMonth() + 1;

  // 获取日期
  let day = today.getDate();

  // 格式化输出，例如：YYYY-MM-DD
  let formattedDate = `${year}${month < 10 ? '0' + month : month}${day < 10 ? '0' + day : day}`;

  console.log(formattedDate);
  return formattedDate;
}

function _shuffleString (val) {
  let arr = val.split('');
  let n = arr.length;
  for (let i = n - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    let temp = arr[i];
    arr[i] = arr[j];
    arr[j] = temp;
  }
  return arr.join('');
}


// WEBPACK FOOTER //
// ./src/util/ossUpload.js